module.exports = __webpack_public_path__ + "static/img/6.c4e1ce2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/2/zh/6.png
// module id = oR3y
// module chunks = 0